export const selectFieldStyles = {
  option:
    'border border-gray50 rounded w-full p-2 focus:outline-none focus:shadow-outline focus:border-blue400 focus:border-2',
  label: 'text-16px font-light text-goEasyGray900',
}
